/**
 * System Role Definitions
 * Defines all available user roles in the system
 */
export enum Role {
  SysAdmin = "SysAdmin",
  Doctor = "Doctor",
  Nurse = "Nurse",
  PSO = "PSO",
  Finance = "Finance",
  Manager = "Manager",
  NurseManager = "Nurse Manager", // Note: Must match legacy system PERMISSION_ROLES.NurseManager
  DoctorAdmin = "Doctor Admin",
  OpsSupport = "Ops Support",
  LabUser = "Lab User",
  BO = "BO",
  Helpdesk = "Helpdesk",
  ChargeCodeManager = "Charge Code Manager", // Note: Must match legacy system PERMISSION_ROLES.ChargeCodeManager
}

/**
 * Role Information Type Definition
 */
export interface RoleInfo {
  id: number;
  name: string;
  precedence: number | null;
  roleGroupId: number | null;
  roleGroup: unknown | null;
  permissions: unknown[];
  systemModules: unknown[];
}
